import { TablePagination } from "@mui/material";
import { useIntl } from "../../contexts/IntlContext";

type StandardTablePaginationProps = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
  /** Oculta o seletor "linhas por página" (ex: telas mobile compactas). */
  hideRowsPerPageLabel?: boolean;
};

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

/**
 * TablePagination pré-configurado com o texto/opções padrão do sistema
 * (chaves i18n `genericList.*`, já usadas pela maioria das listagens).
 */
export function StandardTablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
  hideRowsPerPageLabel = false,
}: StandardTablePaginationProps) {
  const intl = useIntl();

  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      labelRowsPerPage={
        hideRowsPerPageLabel ? "" : intl.formatMessage({ id: "genericList.rowsPerPage" })
      }
      labelDisplayedRows={({ from, to, count: total }) =>
        intl.formatMessage(
          { id: "genericList.displayedRows" },
          {
            from,
            to,
            count:
              total !== -1
                ? total
                : intl.formatMessage({ id: "genericList.moreThan" }, { to }),
          }
        )
      }
    />
  );
}

export default StandardTablePagination;
